import {
  SET_NEW_RELEASE,
  RESET,
  SET_NEW_RELEASE_SUCCESS,
} from '../actions/types'

const defaultState = {
  newRelease: false,
  newReleaseSuccess: false,
}

const toast = (state = defaultState, action) => {
  const { type } = action
  switch (type) {
    case SET_NEW_RELEASE:
      return {
        ...state,
        newRelease: true,
      }
    case SET_NEW_RELEASE_SUCCESS:
      return {
        ...state,
        newReleaseSuccess: true,
      }
    case RESET:
      return {
        ...state,
        newRelease: false,
      }
    default:
      return state
  }
}

export default toast
